import { useQuery } from 'react-query';
import { api } from 'src/api/axios';

export const useDetailPart = (id: number) =>
  useQuery(
    ['detailPart', id],
    async () => {
      if (id) {
        const res = await api.get(`/api/cms/part/${id}`);
        return res.data.data;
      }
      return;
    },
    {
      retry: 0,
    }
  );
